import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAccountStore } from "@/features/accounts/store/useAccountStore";
import { ApiError, assignTransactionsAccount } from "@/services/expenseApi";
import { useAppStore } from "../../store/useAppStore";

/** Shown under the Unassigned filter: give every loaded row one account. */
export default function BulkAssignAccountBar() {
  const transactions = useAppStore((s) => s.transactions);
  const reloadTransactions = useAppStore((s) => s.reloadTransactions);
  const accounts = useAccountStore((s) => s.accounts);
  const ensureAccounts = useAccountStore((s) => s.ensureAccounts);
  const activeAccounts = accounts.filter((a) => a.isActive);
  const [picked, setPicked] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        await ensureAccounts();
      } catch {
        // Without accounts the bar simply stays hidden.
      }
    }
    void load();
  }, [ensureAccounts]);

  const accountId = picked || activeAccounts.find((a) => a.isDefault)?.id || "";
  if (activeAccounts.length === 0 || transactions.length === 0) return null;

  async function handleAssign() {
    setSaving(true);
    try {
      const { updated } = await assignTransactionsAccount(
        transactions.map((t) => t.id),
        accountId,
      );
      toast.success(`${updated} transactions assigned`);
      await reloadTransactions();
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : "Assign failed");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-[10px] border border-border bg-[var(--surface-muted)] px-3 py-2 text-[12px] text-foreground">
      <span>Assign these {transactions.length} to</span>
      <select
        value={accountId}
        onChange={(e) => setPicked(e.target.value)}
        className="rounded-[8px] border border-border bg-card px-2 py-1 text-[12px]"
      >
        {activeAccounts.map((a) => (
          <option key={a.id} value={a.id}>
            {a.name}
            {a.digits ? ` ••${a.digits}` : ""}
          </option>
        ))}
      </select>
      <Button size="sm" onClick={handleAssign} loading={saving}>
        Assign
      </Button>
    </div>
  );
}
